/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.ComAi.TermsAndConditions.Headline';
export const CheckboxLabel = 'Website.ComAi.TermsAndConditions.CheckboxLabel';
export const CheckboxDescription = 'Website.ComAi.TermsAndConditions.CheckboxDescription';
export const Section1 = 'Website.ComAi.TermsAndConditions.Section1';
export const Section2 = 'Website.ComAi.TermsAndConditions.Section2';
export const Section2LinkText = 'Website.ComAi.TermsAndConditions.Section2LinkText';
export const AcceptButton = 'Website.ComAi.TermsAndConditions.AcceptButton';
export const DismissButton = 'Website.ComAi.TermsAndConditions.DismissButton';
